import React from "react";

import ImagePlaceholder from "../ImagePlaceholder";
import { IMAGES } from "../../data/exploreCommunities";

const Step1Picker = ({ selected, onToggle, onNext }) => (
  <div>
    <div className="step-eyebrow">Step 1 of 3</div>
    <div className="step-title">
      What does your ideal Fire Island day look like?
    </div>
    <div className="step-subtitle">
      Select everything that appeals to you — no wrong answers.
    </div>
    <div className="image-grid">
      {IMAGES.map((img) => {
        const isSel = selected.has(img.id);
        return (
          <button
            type="button"
            key={img.id}
            className={`img-card${isSel ? " selected" : ""}`}
            aria-pressed={isSel}
            onClick={() => onToggle(img.id)}
          >
            <ImagePlaceholder
              className="img-card-ph"
              rounded={false}
              src={img.image}
            />
            <div className="img-overlay" />
            <div className="img-label">{img.label}</div>
            <div className="check-badge">
              <svg viewBox="0 0 24 24">
                <polyline points="20 6 9 17 4 12" />
              </svg>
            </div>
          </button>
        );
      })}
    </div>
    <div className="quiz-footer">
      <div className="sel-count">
        <span>{selected.size}</span> selected
      </div>
      <button
        type="button"
        className={`next-btn${selected.size > 0 ? " active" : ""}`}
        disabled={selected.size === 0}
        onClick={onNext}
      >
        See my matches →
      </button>
    </div>
  </div>
);

export default Step1Picker;
